import { statusMap } from '../status/index.js';
import { isHttpErrorStatusCode } from '../typeguards/isHttpErrorStatusCode.js';
import { HttpClientException } from '../base/HttpClientException.js';
import { HttpServerException } from '../base/HttpServerException.js';
import { HttpException } from '../base/HttpException.js';

var createHttpException = function createHttpException(statusCode, msgOrParams) {
  if (isHttpErrorStatusCode(statusCode)) {
    var cls = statusMap === null || statusMap === void 0 ? void 0 : statusMap[statusCode];
    if (cls) {
      return new cls(msgOrParams);
    }
    return statusCode < 500 ? new HttpClientException(statusCode, msgOrParams) : new HttpServerException(statusCode, msgOrParams);
  }
  return new HttpException(statusCode, msgOrParams);
};

export { createHttpException };
